import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-[#08080C]">
        <Loader2 className="w-8 h-8 text-[#FF2E93] animate-spin" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
